module.exports = __webpack_public_path__ + "img/preview.e693cce6.svg";